import React from 'react';
import Modal from 'react-modal';

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: true,
    };
  }

  render() {
    const el = document.querySelector('.abloy-container');
    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.props.closeModal}
        style={customStyles}
        contentLabel="Confirmation Modal"
        appElement={el}
      >
        <div className="confirm-dialog-ak">
          <div className="modal-body">
            <p>{this.props.text}</p>
          </div>
          <div className="modal-footer">
            <button className="btn" onClick={this.props.closeModal}>Cancel</button>
            <button onClick={this.props.confirm}>Ok</button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ConfirmDialog

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};